'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/react-beautiful-dnd/lib/view/get-window-scroll-position.js
// module id = 3029
// module chunks = 0